import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const dMDomainsIgnoreApi = createApi({
  reducerPath: 'dMDomainsIgnoreApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['IgnoreDomains'],
  endpoints: (builder) => ({
    

    getIgnoreDomains: builder.query({
      query: (params) => ({
        url: `/domains/ignore-domains/`,
        params,
      }),
      providesTags: ['IgnoreDomains'],
    }),
    createIgnoreDomain: builder.mutation({
      query: (body) => ({
        url: '/domains/ignore-domains/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['IgnoreDomains'],
    }),
    getIgnoreDomainsId: builder.query({
      query: ({ id, ...params }) => ({
        url: `/domains/ignore-domains/${id}`,
        method: 'GET',
        params,
      }),
      providesTags: (result, error, { id }) => [{ type: 'IgnoreDomains', id }],
    }),
    updateIgnoreDomainById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/domains/ignore-domains/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['IgnoreDomains'],
    }),
    deleteIgnoreDomainById: builder.mutation({
      query: (id) => ({
        url: `/domains/ignore-domains/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['IgnoreDomains'],
    }),

   
  }),
});

export const {
  useGetIgnoreDomainsQuery,
  useLazyGetIgnoreDomainsQuery,
  useCreateIgnoreDomainMutation,
  useUpdateIgnoreDomainByIdMutation,
  useDeleteIgnoreDomainByIdMutation,
} = dMDomainsIgnoreApi;
